<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-admin-order-refund-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>
